const options = {
  5: "bg-green-100/5",
  10: "bg-green-100/10",
  25: "bg-green-100/25",
  50: "bg-green-100/50",
  75: "bg-green-100/75",
  90: "bg-green-100/90",
  100: "bg-green-100",
};

const from = {
  5: "from-green-100/5",
  10: "from-green-100/10",
  25: "from-green-100/25",
  50: "from-green-100/50",
  75: "from-green-100/75",
  90: "from-green-100/90",
  100: "from-green-100",
};

export default function getBackgroundGreen100(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
